import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { faBell } from '@fortawesome/pro-solid-svg-icons';
import { fetchTranslation } from '../../../../../helpers/i18n';

export default function WaitForDocs() {
  return (
    <div className="text-center d-flex flex-column gap-6 my-2">
      <FontAwesomeIcon className="text-branding" icon={faBell} size="2x"/>
      <h5 className="mb-0">
        <strong>{fetchTranslation('youll_be_notified_when_docs_available')}</strong>
      </h5>
      <p className="mb-0">
        {fetchTranslation('all_set_to_view_docs')}
      </p>
    </div>
  );
}
